import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

const TZ = "America/Los_Angeles";
const dayKey = (iso) => new Date(iso).toLocaleDateString("en-CA", { timeZone: TZ });
const dayLabel = (iso) => new Date(iso).toLocaleDateString("en-US", { timeZone: TZ, weekday: "short", month: "short", day: "numeric" });
const timeLabel = (iso) => new Date(iso).toLocaleTimeString("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit" });

export const SlotPicker = ({ value, onChange, refreshKey }) => {
  const [slots, setSlots] = useState(null);
  const [day, setDay] = useState(null);

  useEffect(() => {
    axios.get(`${API}/shop/slots`).then(({ data }) => setSlots(data.slots));
  }, [refreshKey]);

  const days = useMemo(() => {
    const g = {};
    (slots || []).forEach((s) => (g[dayKey(s)] = g[dayKey(s)] || []).push(s));
    return g;
  }, [slots]);

  if (!slots) return <div className="text-xs text-neutral-500">Loading open times…</div>;
  const keys = Object.keys(days);
  const active = day && days[day] ? day : keys[0];
  if (!keys.length) return <div className="text-xs text-neutral-400" data-testid="slots-empty">No open times right now. Please check back soon.</div>;

  return (
    <div data-testid="slot-picker">
      <div className="text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-2">Pick a time (Pacific)</div>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-2">
        {keys.map((k) => (
          <button key={k} type="button" onClick={() => setDay(k)} data-testid={`slot-day-${k}`}
            className={`flex-shrink-0 rounded-lg border px-3 py-2 text-xs transition-colors ${k === active ? "border-amber-400/70 bg-amber-500/15 text-amber-100" : "border-white/10 text-neutral-300 hover:border-white/30"}`}>
            {dayLabel(days[k][0])}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 max-h-40 overflow-y-auto">
        {days[active].map((s) => (
          <button key={s} type="button" onClick={() => onChange(s)} data-testid={`slot-${s}`}
            className={`rounded-lg border px-2 py-2 text-xs whitespace-nowrap transition-colors ${s === value ? "border-amber-400 bg-amber-400 text-black" : "border-white/10 text-neutral-300 hover:border-amber-400/50"}`}>
            {timeLabel(s)}
          </button>
        ))}
      </div>
      {value && (
        <div className="text-xs text-amber-200 mt-2" data-testid="slot-selected">
          {dayLabel(value)} at {timeLabel(value)} Pacific
        </div>
      )}
    </div>
  );
};
